import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { ShieldAlert, LogOut } from "lucide-react";

export default function SuspendedScreen() {
  const { user, logout } = useAuth();
  const isTrialExpired = user?.plan === "trial";
  return (
    <div data-testid="suspended-screen" className="min-h-screen flex items-center justify-center bg-[#0A0D12] px-4">
      <div className="max-w-md w-full bg-[#0F1520] border border-red-500/30 rounded-3xl p-8 text-center">
        <div className="w-16 h-16 rounded-2xl bg-red-500/15 flex items-center justify-center mx-auto mb-5">
          <ShieldAlert className="w-8 h-8 text-red-400" />
        </div>
        <h1 className="text-2xl font-bold font-heading text-slate-100 mb-2">Acesso suspenso</h1>
        <p className="text-sm text-slate-400 mb-6">
          {isTrialExpired
            ? "Seu período de avaliação (trial) expirou. Entre em contato com o administrador para ativar um plano e liberar seu acesso."
            : "Seu acesso está inativo ou com pagamento pendente. Entre em contato com o administrador para regularizar e liberar seu acesso."}
        </p>
        <Button data-testid="suspended-logout-button" onClick={logout}
          className="w-full h-11 bg-red-500 hover:bg-red-600 text-white font-semibold rounded-xl">
          <LogOut className="w-4 h-4 mr-2" /> Sair
        </Button>
      </div>
    </div>
  );
}
